/*
 * Module for the Irs 1099-R Index view
*/

rs.module("ui/content/benefits/irs1099r/index",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors, backendUrls, listApi) {

            // On desktop, details are available on load, so mark the first selected list item as read.
            if (!$.isMobile()) {
                var selectedItem = listApi.selectedItem();

                if (selectedItem) {
                    updateLastViewedDate(selectedItem.item, selectedItem.context.Irs1099RKey);
                }
            }

            // load the corresponding detail when a list item is clicked
            listApi.onItemClick(function (e, context) {
                var item = $(this);
                $.get(
                    backendUrls.getDetailAsync,
                    {
                        irs1099RKey: context.Irs1099RKey,
                        latest1099flag: context.Latest1099Flag
                    })
                    .done(function (html) {
                        listApi.detail.loadDetail(html);

                        updateLastViewedDate(item, context.Irs1099RKey);
                    })
                    .fail(function () {
                        // if the detail retrieve failed, show empty detail
                        listApi.detail.clearDetail();
                    });
            });

            // Update the last viewed date on the selected record.
            function updateLastViewedDate(listItem, irs1099RKey) {
                $.post(
                    backendUrls.saveLastViewedDate,
                    {
                        irs1099RKey: irs1099RKey,
                    }
                ).done(function (result) {
                    // Remove new indicator
                    listItem.js(jsSelectors.newIndicator, { required: false }).remove();
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);